var map = {
	"./en-top-bg.png": "3af8",
	"./es-top-bg.png": "1766",
	"./pt-top-bg.png": "2b39",
	"./th-top-bg.png": "d93c",
	"./vi-top-bg.png": "0e8d",
	"./zh_CN-top-bg.png": "7467"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f95c";